import { render } from "./portal-users.vue?vue&type=template&id=39ac3984&scoped=true"
import script from "./portal-users.vue?vue&type=script&lang=js"
export * from "./portal-users.vue?vue&type=script&lang=js"

import "./portal-users.vue?vue&type=style&index=0&id=39ac3984&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39ac3984"

export default script